import { BaseComponent } from '../base-component'

export class ShareComponent extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    event.preventDefault()
    if (navigator.share) {
      navigator.share({ text: this.dataset.valueToCopy })
    }
  }
}
